import { render, staticRenderFns } from "./SalesOrderPreview.vue?vue&type=template&id=6a039ea0&scoped=true&"
import script from "./SalesOrderPreview.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderPreview.vue?vue&type=style&index=0&id=6a039ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a039ea0",
  null
  
)

export default component.exports